import {
  SET_ALL_EMAILS_SELECTED_CAMPAIGNS,
  SET_ALL_EMAILS_SELECTED_READ_STATUS,
  SET_ALL_EMAILS_SELECTED_STAGE,
  SET_ALL_EMAILS_SELECTED_TAG,
  SET_ALL_SNIPPETS,
  SET_DATE_RANGE,
  SET_SELECTED_INBOX,
  SET_UNREAD_EMAILS_COUNT,
} from './inboxType';

const initialState = {
  allEmailsSelectedCampaigns: [],
  allEmailsSelectedStage: [],
  allEmailsSelectedTag: [],
  allEmailsSelectedReadStatus: false,
  dateRange: [],
  selectedInbox: [],
  allSnippets: [],
  unreadEmailsCount: 0,
};

const inboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_EMAILS_SELECTED_CAMPAIGNS:
      return {
        ...state,
        allEmailsSelectedCampaigns: action.payload,
      };
    case SET_ALL_EMAILS_SELECTED_STAGE:
      return {
        ...state,
        allEmailsSelectedStage: action.payload,
      };
    case SET_ALL_EMAILS_SELECTED_TAG:
      return {
        ...state,
        allEmailsSelectedTag: action.payload,
      };
    case SET_ALL_EMAILS_SELECTED_READ_STATUS:
      return {
        ...state,
        allEmailsSelectedReadStatus: action.payload,
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    case SET_SELECTED_INBOX:
      return {
        ...state,
        selectedInbox: action.payload,
      };
    case SET_ALL_SNIPPETS:
      return {
        ...state,
        allSnippets: action.payload,
      };
    case SET_UNREAD_EMAILS_COUNT:
      return {
        ...state,
        unreadEmailsCount: action.payload,
      };
    default:
      return { ...state };
  }
};

export default inboxReducer;
